export default {
  activity: {
    cycleCount: "活动周期",
    enable: "立即启用",
    consumeTime: "领取时间",
    expendStatus: "状态",
    awardAmountTotal: "累计奖励金额",
    platform: "平台",
    platformSet: "配置平台活动",
    option: "操作",
    operatorTime: "操作时间",
    remark: "备注",
    copySuccess: "复制成功",
    pasteSuccess: "粘贴成功",
    reset: "重置",
    submit: "提交",
    explain: "说明",
    time: "时间",
    title: "标题",
    subtitle: "副标题",
    copy: "复制",
    paste: "粘贴",
    delete: "删除",
    version: "版本",
    amount: '金额',
    code: '活动编号',
    codeAndName: '活动编号/名称',
    name: '活动名称',
    icon: "活动图标",
    uploadIcon: "请上传活动图标",
    content: '内容',
    sort: '排序',
    effectiveTime: '有效时间',
    config: '配置',
    blacklist: '黑名单',
    restart: '重启活动',
    restartMsg1: "确定重启活动,请重新设置活动时间",
    restartMsg2: "確定后，将添加新的版本，活动不会马上启用，需要手动启用。",
    ongoing: '进行中',
    stop: '停止',
    overdue: '过期',
    disbale: "禁止项",
    cancelBlack: '取消黑名单',
    batchCancelBlack: '批量取消黑名单',
    awardNum: '奖励次数',
    totalAward: '累计奖励',
    totalRecharge: '累计充值',
    totalRechargeDay: '累计充值天数',
    rechargeAmount: '充值金额',
    lossAmount: '亏损金额',
    consumptionAmount: '消费金额',
    efficientNum: '有效人数',
    inviteNum: '邀请人数',
    signDay: '签到天数',
    consumption: "打码量",
    withdrawStint: '提现打码量',
    games: '适用游戏',
    award: '奖励金额',
    remainConsumption: "剩余打码量",
    withdrawConsumption: '实际打码量',
    withdrawState: '打码状态',
    withdrawStateRunning: '打码中',
    withdrawStateWait: '待打码',
    withdrawStateComplete: '打码完成',
    effectiveUserConfig: '有效用户设置',
    withdrawCompleteType: "解锁方式",
    withdrawCompleteType1: "用户解锁",
    withdrawCompleteType2: "管理员解锁",
    conditions: '活动条件',
    allowSame: '允许相同',
    unAllowSame: '不允许相同',
    bankCard: '银行卡',
    open: '活动开启',
    close: '活动关闭',
    status: "活动状态",
    status2: "已过期",
    status1: "禁用",
    status0: "启用",
    signInTime: '签到时间',
    lineGames: "打码游戏",
    groupGames: "活动游戏",
    defaultGame: "跳转游戏",
    noSetting: "暂无活动配置",
    inviteUserCount: "邀请用户累计",
    selectGame: "选择游戏",
    selectPage: "选择页面",
    tip: {
      delete: "确定将选择数据删除？删除后需要保存配置才生效。",
      awardAmount: "请输入大于1小于等于15位的整数",
      enable: "更改配置后请先【提交】活动配置，活动状态将改为禁用状态，如需立即启用请点击【立即启用】按钮",
      cycleCount: "请输入大于0小于99999的整数",
    },
    seriesWin: {
      reachAmount: "连续赢订单数",
      reachConditionOne: "投注金额/单笔≥",
      reachConditionTwo: "连续赢金额/单笔≥",
    },
    seriesLost: {
      reachAmount: "连续输订单数",
      reachConditionOne: "投注金额/单笔≥",
      reachConditionTwo: "连续输金额/单笔≥",
    },
  },
}
